export default "__VITE_ASSET__OMeqW_k2__"